import * as React from "react";
import { Button } from "semantic-ui-react";
import { CMD } from "../../helpers/escpos";
import { formatDate } from "../../helpers/date";
import { t } from "../../constant/translations";
import { amountToCurrency, BGN, EUR } from "../../helpers/currency";

const LF = String.fromCharCode(10);

export function PrintReceiptButton(props) {
  const { settlement, transactions, isDev } = props;
  const settlementCurrency = settlement.currency;
  const currency = (amount) => {
    return `${amountToCurrency(
      amount,
      settlementCurrency,
      BGN
    )} / ${amountToCurrency(amount, settlementCurrency, EUR)}`.replace(
      "€",
      "E"
    );
  };

  const renderText = () => {
    let content = `${CMD.TEXT_FORMAT.TXT_ALIGN_CT}${CMD.TEXT_FORMAT.TXT_4SQUARE}
${t("labels.payment")}
${CMD.TEXT_FORMAT.TXT_NORMAL}${settlement.block_details.name}
${CMD.TEXT_FORMAT.TXT_ALIGN_LT}
${t("labels.payment_number")}: ${settlement.id}
${t("resources.estate_capital")}: ${settlement.estate_details.name}
${t("labels.client_number")}: ${settlement.estate_details.vendor_id}
${t("labels.date")}: ${settlement.settle_date}
${t("labels.deposited_amount")}: ${currency(settlement.deposit_amount)}
${t("titles.duties_paid")}: ${currency(settlement.settled_amount)}
${t("labels.prepaid_amount")}: ${currency(settlement.prepaid_amount)}
`;

    transactions.map((trans) => {
      if (!trans.charge) {
        return;
      }
      const details = trans.charge.details;
      content += "--------------------------------";
      content += t("resources.charge_to") + `: ${trans.charge.fund}${LF}`;
      content +=
        t("titles.from_date") +
        `: ${formatDate(trans.charge.charge_date)}${LF}`;

      details.map((detail) => {
        content += CMD.TEXT_FORMAT.TXT_ALIGN_LT;
        content += `${detail.model}${LF}`;
        content +=
          `${detail.value} X ${detail.model_price} ` +
          t(`resources.currency.bgn`) +
          ` (` +
          t("labels.minimum") +
          ` ${detail.model_min_price} ` +
          t(`resources.currency.bgn`) +
          `)${LF}`;
        content += CMD.TEXT_FORMAT.TXT_ALIGN_RT;
        content += `----------${LF}`;
        content += `${detail.amount} ` + t(`resources.currency.bgn`) + `${LF}`;
        content += `${LF}`;
      });
      content += CMD.TEXT_FORMAT.TXT_ALIGN_RT;
      content +=
        t("labels.amount_due") + `: ${currency(trans.charge.amount)}` + `${LF}`;
      content +=
        t("labels.paid_amount") + `: ${currency(trans.amount)}` + `${LF}`;
      content += CMD.TEXT_FORMAT.TXT_ALIGN_LT;
      content += `${LF}`;
    });
    content += `${LF}${LF}`;
    content +=
      `${CMD.TEXT_FORMAT.TXT_ALIGN_CT}${CMD.TEXT_FORMAT.TXT_4SQUARE}` +
      t("labels.official_receipt_cap");
    content += `${LF}${LF}`;
    return content;
  };

  const text = renderText();
  const content = window.encodeURI(text);

  if (isDev) {
    return (
      <Button
        content={t("labels.print")}
        onClick={() => {
          console.log(text);
          console.log(content);
        }}
      />
    );
  }

  return (
    <a href={`rawbt:${content}`}>
      <Button content={t("labels.print")} />
    </a>
  );
}
